export default __webpack_public_path__ + "static/media/outcess3.bff41fab.jpeg";